import * as API from 'common/constant/routes'
import { getJson, postJson, getFile, putFile } from 'helper/http'

export const getHelp = (uuid) => getJson(API.GET_HELP, {}, { uuid })
export const editHelp = (help) => postJson(API.EDIT_HELP, {}, { ...help })
export const getHelpHtml = (url) => getFile(url)
export const uploadFile = (url, file) => putFile(url, file, file.type)
